// Manifesto da arte realmente aplicada ao canvas exportado. Não é prova física.
// Passaporte: uma foto editada vira uma folha com 4 cópias, então conta como
// uma saída por foto, igual à Normal.
const TIPOS_FOTO = ["normal", "polaroid", "fotos_3x4", "passaporte"];
const validId = (value) => typeof value === "string" && /^[A-Za-z0-9_-]{1,128}$/.test(value);
export function buildMolduraUsageManifest({ compraId, totemId, tipoFoto, previews, frames = [], codigoProduto = null, quantidadeFotosPedido = null }) {
  if (!validId(compraId) || !validId(totemId) || !TIPOS_FOTO.includes(tipoFoto)
    || !Array.isArray(previews) || !previews.length || previews.length > 500 || !Array.isArray(frames)) return null;
  const seen = new Set();
  const fotos = [];
  for (const preview of previews) {
    if (!Number.isSafeInteger(preview?.index) || preview.index < 0 || seen.has(preview.index)) return null;
    seen.add(preview.index);
    let serialized;
    try { serialized = JSON.parse(preview.assinatura); } catch (_) { return null; }
    if (!Array.isArray(serialized?.objects)) return null;
    const applied = serialized.objects.filter((item) => item?.tipo === "moldura");
    // Não adivinha a arte pelo nome do produto, URL editada ou seleção do menu.
    const object = applied.length === 1 ? applied[0] : null;
    const frame = object && frames.find((item) =>
      (object.eventoMolduraId && item.dados?.eventoId === object.eventoMolduraId)
      || (!object.eventoMolduraId && object.molduraUsoId && item.id === object.molduraUsoId));
    const recognized = frame && validId(frame.id);
    const origem = recognized ? (frame.dados?.evento === true ? "EVENTO" : "CATALOGO")
      : applied.length ? "SEM_IDENTIFICACAO" : "SEM_MOLDURA";
    fotos.push({ fotoId: `foto-${preview.index}`, saidaId: `saida-${tipoFoto === "polaroid" ? Math.floor(fotos.length / 2) : fotos.length}`,
      molduraId: recognized ? frame.id : null, origem,
      nome: recognized ? (String(frame.dados?.descricao || frame.descricao || frame.id).trim().slice(0, 160) || frame.id) : null,
      global: recognized ? frame.dados?.global === true : false });
  }
  const quantity = typeof quantidadeFotosPedido === "number" ? quantidadeFotosPedido
    : typeof quantidadeFotosPedido === "string" && /^[1-9]\d*$/.test(quantidadeFotosPedido) ? Number(quantidadeFotosPedido) : previews.length;
  return { versao: 1, compraId, totemId, tipoFoto,
    codigoProduto: typeof codigoProduto === "string" && codigoProduto.trim() ? codigoProduto.trim().slice(0, 128) : null,
    quantidadeFotosPedido: Number.isSafeInteger(quantity) && quantity > 0 ? quantity : previews.length, fotos,
    saidas: [...new Set(fotos.map((foto) => foto.saidaId))],
    unidade: tipoFoto === "fotos_3x4" ? "CARTELA" : "FOTO_FINAL" };
}
